function getDurationChartOptions() {
  return {
    colors: ['#0a9e95', '#629f89', '#6fc7a7', '#14688b', '#05b7fc'],
    chart: {
      id: 'duration-chart',
      foreColor: 'white',
    },
    dataLabels: {
      style: {
        colors: ['white'],
      },
    },
    labels: ['<1 min', '1 to 5 mins', '5 to 15 mins', '15 to 30 mins', '>30 mins'],
  };
}

function getBarChartOptions(onDataPointSelection = () => {}) {
  return {
    chart: {
      type: 'bar',
      foreColor: 'white',
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: onDataPointSelection,
      },
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    tooltip: {
      enabled: false,
      style: {
        colors: ['white'],
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ['white'],
      },
      formatter: (val) => {
        if (val !== 0) return val;
        return '';
      },
    },
    xaxis: {
      categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
  };
}

function getDaysInMonthBarChartOptions(daysInMonth, onDataPointSelection = () => {}) {
  // NOTE: Use real month
  return {
    chart: {
      type: 'bar',
      foreColor: 'white',
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: onDataPointSelection,
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        if (val !== 0) return val;
        return '';
      },
      style: {
        colors: ['white'],
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    tooltip: {
      enabled: false,
    },
    xaxis: {
      categories: daysInMonth,
    },
  };
}

export {
  getDurationChartOptions,
  getBarChartOptions,
  getDaysInMonthBarChartOptions,
};
